<template>
  <el-dialog
    title="發送訊息"
    width="30%"
    :before-close="onClose"
    :visible.sync="dialogVisible"
  >
    <el-form ref="form" :model="form" label-width="10rem">
      <el-form-item label="發送對象">
        <el-radio-group v-model="form.picked">
          <el-radio label="all">全體司機</el-radio>
          <el-radio label="one">指定司機</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 只有指定司機會有此欄位 -->
      <el-form-item label="依照服務" v-if="form.picked === 'all'">
        <el-select
          v-model="services"
          @change="onService"
          multiple
          placeholder="篩選服務"
        >
          <el-option
            v-for="{ id, name } in serviceList"
            :key="id"
            :label="name"
            :value="id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="依照狀態" v-if="form.picked === 'all'">
        <span v-if="form.picked === 'all'" style="color: red">移除</span>
        <el-select v-model="status" @change="onStatus" placeholder="篩選狀態">
          <el-option
            v-for="{ name, status } in DRIVER_STATUS_LIST"
            :key="name"
            :label="name"
            :value="status"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item v-if="form.picked === 'one'">
        <span>以上擇一使用</span>
      </el-form-item> -->
      <el-form-item label="輸入隊編" v-if="form.picked === 'one'">
        <el-input
          v-model="form.callnumber"
          placeholder="輸入:022,025,023..."
        ></el-input>
      </el-form-item>
      <el-form-item label="預設訊息">
        <el-select
          v-model="form.defaultMsg"
          placeholder="請選擇"
          @change="onDefaultMsg"
        >
          <el-option
            v-for="{ message } in defaultMsgList"
            :key="message"
            :label="message"
            :value="message"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="訊息內容">
        <el-input
          type="textarea"
          v-model="form.msg"
          placeholder="純文字...最多100個字"
          maxlength="100"
          :autosize="{ minRows: 3 }"
        ></el-input>
      </el-form-item>
      <el-form-item label="重要訊息">
        <el-checkbox v-model="form.isImportant">
          訊息顯示在重要的頁籤中
        </el-checkbox>
      </el-form-item>
      <el-form-item label="需要司機回覆">
        <el-checkbox v-model="form.requireDriverResponse">
          請司機回傳「是」或「否」
        </el-checkbox>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose">關 閉</el-button>
      <el-button
        type="primary"
        icon="el-icon-message"
        @click="onSendMsg"
        :loading="isLoading"
      >
        傳 送
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { reqDefaultMsg, reqTeamServiceList } from '@/api/driverMsg'
import { reqList } from '@/api/driverList'
import { cookies } from '@/utils/cookies'
import { driverStatusList } from '@/constants/driver'
import { Notification } from 'element-ui'

import Message from '@/assets/js/libs/Message'
import Driver from '@/assets/js/libs/Driver'
const driver = new Driver()
const message = new Message()

export default {
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      form: {
        picked:
          'all' /* picked有兩狀態，all代表發送全體司機，one代表發送單一司機*/,
        callnumber: null,
        defaultMsg: null,
        msg: null,
        requireDriverResponse: false,
        isImportant: false,
      },
      defaultMsgList: [],
      serviceList: [],
      driverList: [],
      services: [],
      status: null,
      black: null,
      sendMsgCoolDown: false, // 三秒冷卻旗標，防止連續傳送
    }
  },
  methods: {
    async onStatus(status) {
      /* status = null 為不選擇 */
      if (!status) return
      try {
        const { result } = await driver.getAllDriverLocation(status)
        this.driverList = result.map(({ callNumber }) => callNumber)
        if (this.picked === 'all') {
          this.black = this.driverList.join(',')
        } else {
          this.form.callnumber = this.driverList.join(',')
        }
      } catch (e) {
        console.error(e)
      }
    },
    async onService(val) {
      if (val.length === 0) return
      try {
        const { driverList } = await reqList('general', val.join(','), null)
        this.driverList = driverList.map(({ call_number }) => call_number)
        this.form.callnumber = this.driverList.join(',')
      } catch (e) {
        console.error(e)
      }
    },
    onDefaultMsg(defaultMsg) {
      /* 將預設訊息同步到訊息內容的欄位 */
      this.form.msg = defaultMsg
    },
    async onSendMsg() {
      // 防止三秒內重複點擊傳送
      if (this.sendMsgCoolDown) {
        Notification({
          type: 'warning',
          message: '訊息已傳送，請勿連續點擊',
        })
        return
      }
      if (this.form.picked === 'one' && !this.form.callnumber) {
        Notification({
          type: 'warning',
          message: '推送訊息至單一司機，請輸入呼號',
        })
        return
      }
      if (!this.form.msg) {
        Notification({
          type: 'warning',
          message: '請輸入傳送的訊息',
        })
        return
      }
      // 只要進入送出流程就先設冷卻，確保連點不會觸發多次
      this.sendMsgCoolDown = true
      const coolDownTimer = setTimeout(() => {
        this.sendMsgCoolDown = false
      }, 3000)
      try {
        this.isLoading = false
        const payload = {
          announcer: cookies.get('GladName'),
          teamCode: cookies.get('GladTeamCode'),
          callNumber:
            this.status === 4 || !this.form.callnumber
              ? null
              : this.form.callnumber,
          content: this.form.msg,
          reference: '訊息總表',
          black: this.black,
          is_important: this.form.isImportant,
          require_driver_response: this.form.requireDriverResponse,
          services: this.form.picked === 'one' ? null : this.services,
          status: this.form.picked === 'one' ? null : this.status,
        }
        const { success } = await message.pushDriverMessage(
          payload,
          this.form.picked,
        )
        if (success) {
          this.initModalData()
          Notification({
            type: 'success',
            message: '傳送成功',
          })
        } else {
          Notification({
            type: 'error',
            message: '傳送失敗',
          })
          // 傳送失敗時立即解除冷卻
          clearTimeout(coolDownTimer)
          this.sendMsgCoolDown = false
        }
      } catch (e) {
        console.error(e)
        Notification({
          type: 'error',
          message: '傳送失敗',
        })
        // 發生例外時立即解除冷卻
        clearTimeout(coolDownTimer)
        this.sendMsgCoolDown = false
      } finally {
        this.isLoading = false
      }
    },
    initModalData() {
      this.form = {
        picked: 'all',
        callnumber: null,
        defaultMsg: null,
        msg: null,
        requireDriverResponse: false,
        isImportant: false,
      }
      this.black = null
    },
    openDialog() {
      this.initModalData()
      this.dialogVisible = true
    },
    onClose() {
      this.dialogVisible = false
    },
  },
  async mounted() {
    try {
      const [defaultMsgRes, serviceListRes] = await Promise.all([
        reqDefaultMsg(),
        reqTeamServiceList(),
      ])
      /* 司機預設訊息 */
      if (!defaultMsgRes.result) {
        Notification({
          type: 'error',
          message: '找不到預設的司機訊息',
        })
        this.defaultMsgList = []
      } else {
        this.defaultMsgList = JSON.parse(defaultMsgRes.result)
      }
      /* 司機服務項目 */
      if (!serviceListRes.success) {
        Notification({
          type: 'error',
          message: '找不到司機服務項目',
        })
      } else {
        this.serviceList = serviceListRes.result.serviceList
      }
    } catch (e) {
      console.error(e)
    }
  },
  created() {
    this.DRIVER_STATUS_LIST = driverStatusList
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/message/MessageDialog.vue